<arpio-center-panel>
  <router-outlet></router-outlet>
</arpio-center-panel>
